module.exports = __webpack_public_path__ + "img/Alterna_80X30.832b6733.png";